<template>
    <div class="register-page">
        <top-bar></top-bar>
        <div class="box-register-form">
            <div class="text-head">ลงทะเบียน</div>
            <div class="text-sub-head mb-3">
                กรุณากรอกข้อมูลส่วนตัวของท่านตามที่ระบุด้านล่าง
                หากท่านเคยให้ข้อมูลกับเคาน์เตอร์ความงามชาเนลแล้ว
                กรุณากรอกข้อมูลให้ตรงกัน
            </div>
            <input-text
                inputId="first-name"
                v-model="registerModel.nameTH"
                :inputLbl="lbl.register.firstname_th"
                :isFirstSave="isFirstSave"
                event="click_thai_name_box"
                category="regis_user_info"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[0]"
                :isTextOnly="true">
            </input-text>
            <input-text
                inputId="last-name"
                v-model="registerModel.surnameTH"
                :inputLbl="lbl.register.lastname_th"
                :isFirstSave="isFirstSave"
                event="click_thai_surename_box"
                category="regis_user_info"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[1]"
                :isTextOnly="true">
            </input-text>
            <input-text
                inputId="first-name-en"
                v-model="registerModel.nameEN"
                :inputLbl="lbl.register.firstname_en"
                :isFirstSave="isFirstSave"
                event="click_eng_name_box"
                category="regis_user_info"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[2]"
                :isTextOnly="true"
                :englishOnly="true">
            </input-text>
            <input-text
                inputId="last-name-en"
                v-model="registerModel.surnameEN"
                :inputLbl="lbl.register.lastname_en"
                :isFirstSave="isFirstSave"
                event="click_eng_surename_box"
                category="regis_user_info"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[3]"
                :isTextOnly="true"
                :englishOnly="true">
            </input-text>
            <input-tel
                inputId="contact-number"
                v-model="registerModel.contact_number"
                :inputLbl="lbl.register.contact_number"
                :inputMinLength="12"
                :inputMaxLength="12"
                :isFirstSave="isFirstSave"
                event="click_phone_box"
                category="regis_user_info"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[4]"
                prefix="+66">
            </input-tel>
            <div class="">
                {{ lbl.register.birthdate.name }}
            </div>

            <div class="date form-group">
                <dropdown-date
                    :inputLbl="lbl.register.birthdate"
                    :lbl="lbl.register"
                    :isFirstSave="isFirstSave"
                    :errorInfo="errorInfo[6]"
                    :isFullLbl="true"
                    :inputDisabledDay="true"
                    :inputDisabledMonth="true"
                    :isShowErrorLbl="true"
                    :dayList="day_list"
                    :monthList="month_list"
                    :yearList="year_list"
                    :setDay="formRegister.day"
                    :setMonth="formRegister.month"
                    :setYear="formRegister.year"
                    @onChange="onDateChange($event)"
                    v-if="isLoadedDay"
                ></dropdown-date>
            </div>

            <div class="input-box">
                <drop-down
                    v-if="showCountry"
                    :inputLbl="lbl.register.country"
                    :isFirstSave="isFirstSave"
                    :isShowErrorLbl="false"
                    :errorInfo="errorInfo[5]"
                    :itemList="countryList"
                    :setCountry="objDefaultCountry"
                    v-model="registerModel.country"
                    @input="onChangeCountry($event)">
                </drop-down>
            </div>

            <div class="pt-5">
                <button class="btn-black" @click="submitRegister()">ถัดไป</button>
            </div>

        </div>

        <term-and-con
            view="register"
            @modalConfirmOk="requestOTP"
            :busModal="busModalTerm" >
        </term-and-con>

        <modal-success-with-link
            :busModal="busModalSuccessWithLink">
        </modal-success-with-link>

        <modal-success-page
            :busModal="busModalSuccessPage">
        </modal-success-page>

        <modal-delete-account
            :busModal="busModalDeleteAccount">
        </modal-delete-account>
        <modal
            view="register"
            :busModal="busModal">
        </modal>
        <otp-modal
            :lbl="lbl"
            :busOtpModal="busOtpModal"
            @modalSubmitOtp="submitOtp">
        </otp-modal>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import Locale from "@/helper/locale/locale.js";
import OtpModel from "@/model/OtpModel.js";
import TopBar from "@/components/TopBar.vue";
import InputText from "@/components/common/input/Text.vue";
import InputTel from "@/components/common/input/ContactNumber.vue";
import DropDown from "@/components/common/input/Dropdown.vue";

import Vue from "vue";
//import DatePicker from "vuejs-datepicker"; // https://www.npmjs.com/package/vuejs-datepicker
// import VCalendar from 'v-calendar'; // https://vcalendar.io/installation.html
// import Calendar from 'v-calendar/lib/components/calendar.umd'
// import DatePicker from 'v-calendar/lib/components/date-picker.umd'; // https://vcalendar.io/installation.html
import { th } from "vuejs-datepicker/dist/locale";

import Register from "@/helper/RegisterHelper.js";
import Modal from "@/components/modal/Modal.vue";
import TermAndCon from "@/components/modal/TermAndCondition.vue";
import ModalSuccessWithLink from "@/components/register/ModalSuccessWithLink.vue";
import ModalSuccessPage from "@/components/register/ModalSuccessPage.vue";
import ModalDeleteAccount from "@/components/modal/ModalDeleteAccount.vue";
import OtpModal from "@/components/modal/OtpModal.vue";
import Account from "@/helper/AccountHelper.js";
import BzbsApi from "@/service/BzbsApi.js";
import DropdownDate from "../../../components/register/DropdownDate.vue";
import { TrackingService } from "@/helper/TrackingHelper.js"
import CacheHelper from "@/helper/CacheHelper.js";

export default {
  name: "Register",
  components: {
    TopBar,
    InputText,
    InputTel,
    // DatePicker,
    TermAndCon,
    Modal,
    ModalSuccessWithLink,
    ModalSuccessPage,
    ModalDeleteAccount,
    //DatePicker,
    // otp
    OtpModal,
    DropDown,
    DropdownDate,

  },
  data: function () {
    return {
        lbl: Locale.getLbl(),
        isFirstSave: true,
        objUser: {},
        isLogin: false,
        isLoadedDay: false,

        registerModel: {
            nameTH: "",
            surnameTH: "",
            nameEN: "",
            surnameEN: "",
            contact_number: "",
            otp: "",
            refcode: "",
            boutiqueId: "",
            sourceId: "",
            countryCode: "",

        },

        birthdateVal: "",

        errorInfo: [],
        busModal: new Vue(),
        busModalTerm: new Vue(),
        busModalSuccessWithLink: new Vue(),
        busModalSuccessPage: new Vue(),
        busModalDeleteAccount: new Vue(),

        datePickerLang: th,
        // otp
        objauthRequestOTPConfig: null,
        objError: null,
        busOtpModal: new Vue(),

        registerHelper: new Register(),
        tracking: new TrackingService(this),
        countryList: [],
        showCountry: false,
        configRegisterSuccess: null,
        isLodedConfig: false,
        disabledDates: {
            from: new Date(),
            // to: new Date(Date.now() + 8640000)
        },

        month_list: [
            { value: '1', text: 'มกราคม'},
            { value: '2', text: 'กุมภาพันธ์'},
            { value: '3', text: 'มีนาคม'},
            { value: '4', text: 'เมษายน'},
            { value: '5', text: 'พฤษภาคม'},
            { value: '6', text: 'มิถุนายน'},
            { value: '7', text: 'กรกฎาคม'},
            { value: '8', text: 'สิงหาคม'},
            { value: '9', text: 'กันยายน'},
            { value: '10', text: 'ตุลาคม'},
            { value: '11', text: 'พฤศจิกายน'},
            { value: '12', text: 'ธันวาคม'}
        ],
        formRegister: {
            day: {
                value: "",
                text: ""
            },
            month: "",
            year: "",
        },
    };
},
  created: function () {

    this.tracking.screenName("regis_user_info");
    this.tracking.event("regis_user_info", "view_regis_user");

    Account.loginStatus().then((status) => {

    	this.isLogin = status;
    	if (this.isLogin == true) {
    	  	this.objUser = Account.getCacheUser();
    	  	if (this.objUser.userLevel > 0) {
    	    	var path = "/campaign";
    	    	this.$router.push(path);
    		}
    	} else {
    	  this.addUserByTag();
    	}
    });
    var inputCont = 7;
    for (var i = 0; i < inputCont; i++) {
    	this.errorInfo.push({
    		isValid: true,
    		msg: "",
    	});
    }


    this.formRegister.day.value = 1;
    this.formRegister.day.text = 1;
    this.formRegister.month = this.month_list[0];
    //this.formRegister.year = d.getFullYear();


    this.genday(31);
    //this.genyear(100);
    var month = {
        text: this.lbl.register.month,
        value: this.lbl.register.month
    }
    this.month_list.unshift(month)
    this.getDefaultCountry();

    this.authStart();
  },
  mounted: function() {
    // this.busModalSuccessWithLink.$emit("showModal", "", "123456");
  },
  methods: {

    submitRegister: function () {
        this.tracking.event("regis_user_info", "click_next_to_consent");
        console.log(this.registerModel.country);
        this.isFirstSave = false;
        Util.log(this.registerModel);
        if (this.validateRegister()) {
            var objRegisterconfig = {
                birthdate: this.formRegister.date,
                registerModel: this.registerModel,
                contac_number: this.registerModel.contact_number,
                tag: 'register_term',
            }
            this.$emit('onClicknext', objRegisterconfig);
        }
    },
    validateRegister: function () {
    	Util.log(this.errorInfo);
    	for (var i of this.errorInfo) {
    		if (!i.isValid) {
    		  return false;
    		}
    	}

   		// if (Util.isEmptyStr(this.registerModel.birthdate)) {
   		//     return false;
   		// }

      	return true;
    },

    showTermAndCon: function () {
    	this.busModalTerm.$emit("showConfirmModal");
    },
    showModalTest: function () {
    	// this.busModalSuccessWithLink.$emit('showModal');
    	// this.busModalSuccessPage.$emit('showModal', {type: 'ticket'});

    	// this.busModal.$emit('showConfirmModal', {
    	//     title: 'ลบบัญชีผู้ใช้' ,
    	//     message: 'คุณต้อการลบบัญชีผู้ใช้<br>ของ Chanel ใช่หรือไม่',
    	//     strBtnOk: 'ยืนยัน',
    	//     strBtnCancel: 'ยกเลิก',
    	//     tag: 'confirm-delete',
    	// });

    	this.busModalDeleteAccount.$emit("showModal");
    },
    requestOTP: function () {
    	this.objauthRequestOTPConfig = new OtpModel.AuthRequestOTPConfigModelBuilder().create();
    	this.objauthRequestOTPConfig.strContactNumber = this.registerModel.contact_number;
    	this.objauthRequestOTPConfig.strChannel = "Register";
    	this.busOtpModal.$emit("showOtpModal", this.objauthRequestOTPConfig);
    },

    submitOtp: function (objOtp) {
    	this.registerModel.refcode = objOtp.refcode;
    	this.registerModel.otp = objOtp.otp;
    	var boutiqueId = Account.getCacheCustom("boutiqueId");
    	if (boutiqueId) {
    	  this.registerModel.boutiqueId = boutiqueId;
    	}

    	var sourceId = Account.getCacheCustom("sourceId");
    	if (sourceId) {
    	  this.registerModel.sourceId = sourceId;
    	}

    	//   if (this.birthdateVal && this.birthdateVal != "") {
    	//     var birthdateStr = this.birthdateVal
    	//       .toLocaleDateString("en-GB")
    	//       .split("/");
    	//     this.registerModel.birthdate =
    	//       birthdateStr[2] + "-" + birthdateStr[1] + "-" + birthdateStr[0];
    	//   }
    	if (this.formRegister) {
    	    this.registerModel.birthdate =
    	       this.formRegister.year + "-" + this.formRegister.month + "-" + this.formRegister.day;
    	}
        var cache = new CacheHelper('cookie');
        let isReward = cache.getCache('reward');

        if(isReward){
            this.registerModel.reward = isReward;
        }

    	var param = Util.normalObject(this.registerModel);
    	var token = Account.getToken();
    	this.busModal.$emit("showLoadingModal");
    	this.registerHelper
        	.sendRegister(token, param)
        	.then((objResult) => {
        	this.busModal.$emit("hideLoadingModal");
        	Util.log(objResult);
        	Account.apiGetProfile();
        	this.busOtpModal.$emit("hideOtpModal", {});

        	// var target_page = Account.getCacheCustom("target_page");
        	// var campaignid = Account.getCacheCustom("campaignId");
        	// var campaignType = Account.getCacheCustom("campaignType");
        	// clear cache success register
        	var target_page = JSON.parse(Account.getCacheCustom("target_page"));
        	var campaignid = JSON.parse(Account.getCacheCustom("campaignId"));
        	var campaignType = JSON.parse(Account.getCacheCustom("campaignType"));

        	Account.removeCacheCustom("target_page");
        	Account.removeCacheCustom("campaignId");
        	Account.removeCacheCustom("campaignType");


        	if (target_page == "campaign") {
            	///landing/line?liff.state=target_page=campaign&campaignid=91677
            	//"/landing/line?liff.state=%3FboutiqueId%3Dxxxx%26sourceId%3Dyyyy%26target_page%3Dcampaign%26campaignid%3D549070&state=line_authorize"
            	var paramstr =
            	  "?3FboutiqueId=xxxx&target_page=" +
            	  target_page +
            	  "&campaignid=" +
            	  campaignid;
            	  //Account.removeCacheCustom("campaignId");
            		//paramstr = encodeURIComponent(paramstr);
            		//  window.location.href = "/landing/line?liff.state=" + paramstr;
            	if (campaignType == Vue.CampaignType.Free) {
            		this.busModalSuccessPage.$emit("showModal", {
            	    	type: "ticket",
            	    	paramStr: paramstr,
            		});
            	} else if (campaignType == Vue.CampaignType.Deal) {
            			this.busModalSuccessPage.$emit("showModal", {
            	    	type: "campaign",
            	    	paramStr: paramstr,
            		});
            	} else {
            		this.busModalSuccessWithLink.$emit("showModal");
            	}
          	} else {
                if (isReward) {
                    this.busModalSuccessWithLink.$emit("showModal", "", "123456");
                } else {

                    this.busModalSuccessWithLink.$emit("showModal");
                }
          	}
        })
        	.catch((error) => {
        	  this.busModal.$emit("hideLoadingModal");
        	  if (error.response)
        	    this.busOtpModal.$emit("showErrorOtpModal", error);
        	  else
        	    this.busModal.$emit("showAlertModal", this.$configModalNoConnect);
        	});
    	},
		authStart: function () {
			var token = Account.getToken();
			this.registerHelper.authStart(token).catch((error) => {
				this.busModal.$emit("hideLoadingModal");
				this.busModal.$emit("showAlertModal", error);
			});
		},
		addUserByTag: function () {
			var tag = Account.getCacheCustom("tag");
			var strBzbsToken = Account.getToken();
			if (tag) {
				var params = {};
				params.tag = tag;

				var strUrl = Vue.bzbsConfig.newBzbsModuleUrl + "/campaign/tag";
				return new Promise(() => {
				BzbsApi.connectBzbsGet(strUrl, strBzbsToken, params)
					.then((response) => {
					    console.log(response);
					})
					.catch((error) => {
					    console.log(error);
					});
				});
			}
		},
		onChangeCountry: function (data) {
			this.registerModel.country = data.id;
			this.registerModel.countryCode = data.name;
		},
		getConfigCountry: function () {
			var strBzbsToken = Account.getToken();
			var params = {};
			//var strUrl = BzbsApi.apiUrl + "/api/config/" + strConfig;
			var strUrl = Vue.bzbsConfig.newBzbsUrl + "/config/chanel_country";
			return new Promise(() => {
				BzbsApi.connectBzbsGet(strUrl, strBzbsToken, params)
				.then((response) => {
					this.countryList = response.data;
					this.showCountry = true;
					console.log(this.countryList);

					// var value = {
                    //     name: "Thailand",
                    //     id: "TH",
					// };
					// this.objDefaultCountry = value;
				})
				.catch((error) => {
					console.log(error);
					if (!error.response) {
					    this.showErrorInternet();
					}
				});
			});
		},
        getDefaultCountry: function () {
            var strBzbsToken = Account.getToken();
			var params = {};
			//var strUrl = BzbsApi.apiUrl + "/api/config/" + strConfig;
            const currentTime = new Date().getTime();
			var strUrl = Vue.bzbsConfig.newBzbsUrl + "/config/chanel_default_country?time="+currentTime;
			return new Promise(() => {
				BzbsApi.connectBzbsGet(strUrl, strBzbsToken, params)
                    .then((response) => {
                        this.objDefaultCountry = response.data;
                        this.getConfigCountry();
                    })
                    .catch((error) => {
                        console.log(error);
                        if (!error.response) {
                            this.showErrorInternet();
                        }
                    });
			});
        },

		showErrorInternet: function () {
            var configModal = {
                title: null,
                message: "พบปัญหาการเชื่อมต่อ",
                strBtnOk: "ปิด",
                tag: "nointernet",
		    };
		    this.busModal.$emit("showAlertModal", configModal);
		},
    	genday: function(num) {
            //this.isLoadedDay = false;
            var i = 1;
            this.day_list = [];
            var objday = {
                value: "",
                text: ""
            };
            //this.day_list.push(objday);
            for(i = 1 ;i<=num;i++) {
                objday = {
                    // value: i < 10 ? "0"+i : i.toString(),
                    value: i.toString(),
                    text: i.toString()
                }
                this.day_list.push(objday);
            }
            var date = {
                text: this.lbl.register.day,
                value: this.lbl.register.day
            }
            this.day_list.unshift(date)
            this.$nextTick(() => { // ES6 arrow function
                // this.isLoadedDay = true;
                this.formRegister.year = this.day_list[0];
                this.genyear(100);
            })
        },
		genyear: function() {
			var d = new Date();
			var n = (d.getFullYear()+1) - 20;
			var i = 100;
			this.isLoadedYear = false;
			this.year_list = [];
			var objday = {
				value: "",
				text: ""
			};

			//this.year_list.push(objday);

			for(i;i>0;i--) {
				objday = {
					value: i.toString(),
					text: n = n-1,
				}
				this.year_list.push(objday);
			}
             var date = {
                text: this.lbl.register.year,
                value: this.lbl.register.year
            }
            this.year_list.unshift(date)
			this.$nextTick(() => { // ES6 arrow function
				this.formRegister.year = this.year_list[0];
				this.isLoadedDay = true;
			})
		},
		onDateChange: function(data) {
            if (!data) {
                this.formRegister.date = null;
                return
            }
			if (data.day < 10) {
				data.day = "0" + data.day;
			}
			if (data.month < 10) {
				data.month = "0" + data.month;
			}

            this.formRegister.date =  data.year+"-"+ data.month+"-"+ data.day;
			//this.formRegister.registerdate = data.year - 543 +"-"+ data.month+"-"+ data.day;
		},
  	},
};
</script>
<style lang="scss" scoped>
    @import "@/style/page/Register.scss";
</style>
<style lang="scss">
    $url-dropdown-icon: url("../../../assets/icon/Shape 790@2x.png");
    @import "@/style/Input/Dropdown.scss";
    @import "@/style/tools/calendar.scss";
    @import "@/style/base/component/baseinput.scss";

    .input-icon-calendar {
        @extend %input-base-custom;
        background-image: url("../../../assets/img/icon_bd.png");
        background-position-x: calc(100% - 10px);
        font-family: "Prompt-regular";
        padding-left: 10px;
    }
    .calendar-custom {
        top: -290px;
    }
</style>

